import css from "./style.scss";
import cx from "classnames";
import Circle from "react-circle";
import useInvoice from "../../hooks/useInvoice";

const Timer = () => {
  const { invoice } = useInvoice();
  const minuts = Math.floor(invoice.timeLeft / 60);
  const seconds = invoice.timeLeft % 60;
  const minutsString = minuts < 1 ? "00" : minuts >= 10 ? minuts : "0" + minuts;
  const secondsToString = seconds < 10 ? "0" + seconds : seconds;
  const timeToString = `${minutsString}:${secondsToString}`;
  const totalTime = 600;
  const percent = Math.ceil((invoice.timeLeft / totalTime) * 100);
  return (
    <div class={cx(css.wrapper)}>
      <Circle
        progressColor="#444CE7"
        animate={invoice.timeLeft > 0}
        roundedStroke
        showPercentage={false}
        size={80}
        progress={percent}
      />
      <div class={cx(css.numbers)}>{timeToString}</div>
    </div>
  );
};
export default Timer;
